const resetPopinStyles = {
  confirmationItem: {
    marginTop: 22
  },
  credentials: {
    marginBottom: 16,
  }
}

export default resetPopinStyles
